
const BookmarkIcon = (props: any = {}) => {
    return (
        <svg width="24" height="24" {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.4 12C0.4 5.5935 5.5935 0.4 12 0.4C18.4065 0.4 23.6 5.5935 23.6 12C23.6 18.4065 18.4065 23.6 12 23.6C5.5935 23.6 0.4 18.4065 0.4 12Z" fill="white" stroke="#EDEBEC" strokeWidth="0.8" />
            <path fillRule="evenodd" clipRule="evenodd" d="M6.67591 11.7655C6.04999 9.81131 6.78149 7.57773 8.83307 6.91681C9.91224 6.56856 11.1036 7.32483 12.0007 7.99975C12.8495 7.3435 14.0842 6.5709 15.1622 6.91681C17.2138 7.57773 17.95 9.81131 17.3247 11.7655C16.3505 14.863 12.0006 17.2488 12.0006 17.2488C12.0006 17.2488 7.68274 14.8991 6.67591 11.7655Z" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default BookmarkIcon